import React from "react";
import PageHero from "../components/PageHero";
import FinalCta from "../components/FinalCta";
import StatsCounter from "../components/StatsCounter";
import { motion } from "framer-motion";
import { PROCESS_STEPS, BRAND, IMG } from "../lib/content";

export default function About() {
  return (
    <main data-testid="about-page">
      <PageHero
        eyebrow="About Reflex"
        title="Two generations of"
        italic="stone craft."
        subtitle="A Sydney studio built by craftsmen, for the country's most discerning architects, designers and homeowners."
        image={IMG.blackStaircase}
      />

      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <div className="img-zoom-wrap">
              <img
                src={IMG.harborView}
                alt="Polished marble floor with Sydney harbour view"
                className="w-full h-[520px] object-cover"
              />
            </div>
          </div>
          <div className="lg:col-span-7">
            <h2 className="font-display-bold text-3xl md:text-5xl tracking-tighter text-[#0A0A0A]">
              Built on the conviction that natural stone deserves to be
              <span className="font-serif-italic font-light text-[#B8965A]"> looked after, not replaced.</span>
            </h2>
            <div className="mt-10 space-y-6 text-[#525252] text-[15px] md:text-base leading-relaxed">
              <p>
                Reflex Stone Care was founded by craftsmen with backgrounds in European
                stone trades and {BRAND.experienceYears}+ years of combined experience across
                Australia's most prestigious residential and hospitality projects.
              </p>
              <p>
                We believe stone is the most honest material in any home — but the
                most demanding to care for. Every project we touch is treated as
                architecture: assessed, planned, executed and finished to a standard
                we'd want in our own homes.
              </p>
              <p>
                Today our crews work across Sydney and the Central Coast, restoring
                heritage terrazzo lobbies, mirror-polished Calacatta benchtops,
                limestone bathrooms and granite façades. The stone changes. The
                obsession with detail does not.
              </p>
            </div>
          </div>
        </div>
      </section>

      <StatsCounter />

      <section className="py-24 md:py-32 bg-[#F7F4F0]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 text-[#B8965A]">
            <span className="block w-8 h-px bg-[#C9A86A]" />
            <span className="text-[11px] uppercase tracking-[0.3em]">Our Process</span>
          </div>
          <h2 className="mt-6 font-display-bold text-4xl md:text-5xl lg:text-6xl tracking-tighter text-[#0A0A0A] max-w-3xl">
            Considered, calibrated, <span className="font-serif-italic font-light text-[#B8965A]">flawless.</span>
          </h2>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10">
            {PROCESS_STEPS.map((step, i) => (
              <motion.div
                key={step.n}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className="bg-white p-8 md:p-10 min-h-[260px]"
              >
                <span className="font-serif-italic text-[#B8965A] text-2xl">{step.n}</span>
                <h3 className="mt-6 font-display-bold text-2xl tracking-tight text-[#0A0A0A]">{step.title}</h3>
                <p className="mt-4 text-[15px] leading-relaxed text-[#525252]">{step.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <FinalCta />
    </main>
  );
}
